import { useState, useCallback } from "react";
import { api } from "../lib/api";
import { idsFor } from "../lib/modules";
import { publicIpRequest } from "../../utils/publicIpTargets";

// One external risk scan.
//
// POST s2/api/domain-scan is a single blocking request: it returns only when every
// module has finished. There is no streaming endpoint, no progress payload and no
// cancel route, so this hook exposes a plain `running` flag rather than pretending to
// know a percentage.
export function useDomainScan() {
  const [running, setRunning] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState("");

  const run = useCallback(async ({ domain, groups, organizationId, breachEmails, publicIps, publicIpMode = "auto" }) => {
    setRunning(true); setError(""); setResults(null);
    try {
      const data = await api.post("s2/api/domain-scan", {
        target: domain,
        targetType: "domain",
        modules: idsFor(groups),
        ...publicIpRequest({ target: domain, enabled: groups.includes("infra"), mode: publicIpMode, manual: publicIps || "" }),
        oneTime: true,
        organizationId,
        // Whitespace-separated, same as the original.
        hibpEmails: (breachEmails || "").trim().split(/\s+/).filter(Boolean),
      });
      setResults(data);
      return data;
    } catch (e) {
      setError(e.message || "Scan failed.");
      return null;
    } finally {
      setRunning(false);
    }
  }, []);

  const reset = useCallback(() => { setResults(null); setError(""); }, []);

  return { run, reset, running, results, error };
}
